import { checkExhaustiveness } from '../../../../util'
import { CUSTOM_CHART_BLOCK_TITLE, CUSTOM_CHART_BLOCK_TYPE, defaultCustomChartBlockConfig } from './charts'
import { COMMENTS_BLOCK_TITLE, COMMENTS_BLOCK_TYPE, defaultCustomCommentsBlockConfig } from './comments/config'
import { CUSTOM_TEXT_BLOCK_TITLE, CUSTOM_TEXT_BLOCK_TYPE } from './customText/config'

export const BLOCK_ADD_BLOCK_TYPE = 'BLOCK_ADD'

/** @type {import('./config.types').GridBlocksEnum} */
export const GridBlocksEnum = {
  [CUSTOM_TEXT_BLOCK_TYPE]: CUSTOM_TEXT_BLOCK_TYPE,
  [COMMENTS_BLOCK_TYPE]: COMMENTS_BLOCK_TYPE,
  [CUSTOM_CHART_BLOCK_TYPE]: CUSTOM_CHART_BLOCK_TYPE,
  [BLOCK_ADD_BLOCK_TYPE]: BLOCK_ADD_BLOCK_TYPE
}

/** @type {import('./config.types').GridBlockTitles} */
export const GridBlockTitles = {
  [CUSTOM_TEXT_BLOCK_TYPE]: CUSTOM_TEXT_BLOCK_TITLE,
  [COMMENTS_BLOCK_TYPE]: COMMENTS_BLOCK_TITLE,
  [CUSTOM_CHART_BLOCK_TYPE]: CUSTOM_CHART_BLOCK_TITLE
}

export const ConfiglessBlocks = [GridBlocksEnum.CUSTOM_TEXT, GridBlocksEnum.BLOCK_ADD]

/**
 * @param {import('./config.types').CustomGridBlocksWithConfigs} type
 * @param {*} module
 * @returns
 */
export const defaultConfig = (type, module) => {
  if (type === GridBlocksEnum.COMMENTS) {
    return defaultCustomCommentsBlockConfig(module.criteria[0])
  }
  if (type === GridBlocksEnum.CUSTOM_CHART) {
    return defaultCustomChartBlockConfig()
  }
  checkExhaustiveness(type)
}

/**
 * @param {import('./config.types').BlockType} type
 * @param {*} config
 * @returns
 */
export const noRender = (type, config) => {
  switch (type) {
    case GridBlocksEnum.COMMENTS:
      return config.showQuestionComments || config.showThemeComments

    case GridBlocksEnum.CUSTOM_CHART:
      return !!type && !!config

    default:
      return false
  }
}
